import {
  contextMenuEditIcon,
  // exportFullTrade,
  newWindowIconForRightClick,
  offloadRiskForRightClick,
  plusForRightClick,
} from "@/components/icons/SVGIcons";
import {
  actionsConfigOP,
  actionsConfigRP,
  getEnumKeyByEnumValue,
  IActionObj,
} from "@/components/widgets/tradeActionSummary/helper/actionButtonsHelper";
import { ExecutionStrategyStatus } from "@/lib/interfaces and Enums/ENUMExecutionStrategyStatus";
import { isEditPanelAllowedAtStatus } from "@/components/widgets/tradeActionSummary/helper/colDefs/colDefsShared";
import { newPopOutWindow, onAddWidget } from "@/lib/widgetHelperFunctions";
import { baseWidgetDetails, IbaseWidgetDetails } from "@/lib/widgetsLayoutDir";
import {
  notDealtStoreAction,
  offloadRiskStoreAction,
} from "@/store/tradeDataStoreACTIONS";
import { User } from "@auth0/auth0-react";
import { GetContextMenuItemsParams, MenuItemDef } from "ag-grid-community";
import { Dispatch, SetStateAction } from "react";
import { toast } from "react-toastify";
import { hasRecoupon } from "../ActionSummaryOP/selectPanel/GetExecutionContextMenuItems";
import {
  defaultExpandedRowContext,
  IdefaultExpandedRowContext,
} from "../ActionSummaryTableHelperFunctions";
import {
  returnAllocationsViewerArray,
  returnLegsViewerArray,
} from "../helper/contextMenu/allocationsAndLegsViewerArrays";
import {
  clearAllFiltersContextMenuObject,
  collapseAllExpandedRowsContextMenuObject,
  returnToLiveTradesContextMenuItems,
  returnToggleSettingsContextMenuObject,
} from "./genericContextMenuItems";
import { returnEditExpiryMenuPlacement } from "./expiryContextMenuItem";
import featureFlagStore from "@/store/featureFlagStore";
import tradesInProcessStore from "@/store/tradesInProcessStore";
import {
  extractSelectedESIDs,
  sellSideExport,
  userSpecificExport,
} from "./rightClickContextExportHelpersACTIONS";
import { isActionAllowedByFills } from "../helper/fillStateHelpers";
import {
  canOffloadRisk,
  resolveOffloadExecutionRequestId,
} from "./offloadRiskHelpers";

interface IaddNewButtonProps extends IbaseWidgetDetails {
  esid?: string;
}

function returnEditPanelName(
  params: GetContextMenuItemsParams<any, any>,
  expandedRowsContext: IdefaultExpandedRowContext[],
) {
  const currentExpandedRowsContext = [...expandedRowsContext];
  const findSettingsForCurrentESID = currentExpandedRowsContext.find(
    (expandedSetting) => {
      return expandedSetting.esid == params.node?.data.esid;
    },
  );
  if (findSettingsForCurrentESID == undefined) {
    return "Edit Panel";
  }
  return findSettingsForCurrentESID.editPanelShowing
    ? "Close Panel"
    : "Edit Panel";
}

const GetContextMenuItemsActionSummary = (
  params: any,
  user: User | undefined,
  getAccessTokenSilently: Function,
  expandedRowsContext: IdefaultExpandedRowContext[],
  setExpandedRowsContext: React.Dispatch<
    React.SetStateAction<IdefaultExpandedRowContext[]>
  >,
  setExpandedRowsContextMostRecentlyUpdated: Dispatch<SetStateAction<string>>,
  expandedRowsContextCurrent: IdefaultExpandedRowContext[],
  cryptoID: string | undefined,
  theme?: any,
) => {
  const defaultItems = ["copy", "copyWithHeaders", "separator", "export"];

  // Related to Quote Import Requirement.
  // const customExport = [
  //   {
  //     name: "Export Full Trade",
  //     icon: exportFullTrade,
  //     action: () => downloadCSV(params),
  //   },
  // ];

  const tradeAction = [
    {
      name: "New Trade Tile",
      icon: plusForRightClick,
      action: (params: any) => {
        const newComponentToAdd = baseWidgetDetails.find(
          (widget) => widget.component == "TradeTile",
        );
        if (newComponentToAdd) {
          const copyOfNewComponent: IaddNewButtonProps = { ...newComponentToAdd };
          copyOfNewComponent.esid = params.node.data.esid;
          delete copyOfNewComponent.icon; // Prevents the "Icon" getting saved to the dataBase.
          onAddWidget(copyOfNewComponent);
        }
      },
    },
    {
      name: "Pop out trade window",
      icon: newWindowIconForRightClick,
      action: () => {
        newPopOutWindow("Tile", params.node.data.esid);
      },
    },
  ];

  const isReCreated =
    params.node?.data?.status === ExecutionStrategyStatus.ReCreated;

  const viewAllocationsActions = isReCreated
    ? []
    : [
        returnAllocationsViewerArray({
          params,
          expandedRowsContext,
          setExpandedRowsContext,
          setExpandedRowsContextMostRecentlyUpdated,
          getAccessTokenSilently,
        }),
      ];

  const viewLegsActions = isReCreated
    ? []
    : [
        returnLegsViewerArray({
          params,
          expandedRowsContext,
          setExpandedRowsContext,
          setExpandedRowsContextMostRecentlyUpdated,
          getAccessTokenSilently,
        }),
      ];

  // 14868 - Revert code related to "/Trade/Execution/Recoupon" and ReCoupon flow.
  // const recouponActions = [
  //   returnRecouponArray({
  //     params,
  //     expandedRowsContext,
  //     setExpandedRowsContext,
  //     setExpandedRowsContextMostRecentlyUpdated,
  //     getAccessTokenSilently,
  //   }),
  // ];

  // 14868 - Revert code related to "/Trade/Execution/Recoupon" and ReCoupon flow.
  // const updateExecutionButton = [
  //   {
  //     name: "Recoupon",
  //     action: () => {
  //       recouponTradeAction({
  //         data: params.node.data,
  //         getAccessTokenSilently: getAccessTokenSilently,
  //       });
  //     },
  //   },
  // ];

  const editPanelActions = [
    {
      name: returnEditPanelName(params, expandedRowsContext),
      icon: contextMenuEditIcon,
      cssClasses: [
        "EditPanelActionButtonER",
        theme == "light" ? "actionButtonERLight" : "actionButtonERDark",
      ],
      action: () => {
        params.node.setExpanded(true);
        const currentExpandedRowsContext = [...expandedRowsContext];
        const findSettingsForCurrentESID = currentExpandedRowsContext.find(
          (expandedSetting) => {
            return expandedSetting.esid == params.node.data.esid;
          },
        );
        if (findSettingsForCurrentESID == undefined) {
          // Add a new obj if needed.
          const newSettings = { ...defaultExpandedRowContext };
          newSettings.esid = params.node.data.esid; // Only on the ES level.
          newSettings.editPanelShowing = true;
          setExpandedRowsContext([...currentExpandedRowsContext, newSettings]);
        } else {
          const adjustedCurrentSettingsArray = currentExpandedRowsContext.map(
            // Adjust current settings.
            (settingsObj) =>
              settingsObj.esid == findSettingsForCurrentESID!.esid
                ? {
                    ...settingsObj,
                    editPanelShowing: !settingsObj.editPanelShowing,
                    allocationsShowing: false,
                    legsShowing: false,
                  }
                : settingsObj,
          );
          setExpandedRowsContext(adjustedCurrentSettingsArray);
        }
        setExpandedRowsContextMostRecentlyUpdated(params.node.data.esid); // String to trigger flag of which row to redraw.
      },
    },
  ];

  let actionButtons: (string | MenuItemDef)[] = [];
  const getActions = (structureType: string, status: string) => {
    const keyToPass = getEnumKeyByEnumValue(ExecutionStrategyStatus, status);
    if (keyToPass) {
      return params?.node?.data?.role == "OP"
        ? actionsConfigOP[structureType]?.[keyToPass] || []
        : actionsConfigRP[structureType]?.[keyToPass] || [];
    } else return [];
  };
  if (params.node) {
    // Early return if a user tries to right click while using row grouping.
    if (!params.node.data) {
      return [];
    }

    let type = params.node.data.type;
    if (params.node.data.type == "Not Sent") {
      type = "NotSent";
    }
    let actionsList = [];
    if (
      // 14252 - RP shows a 'Recoupon' button if there is at least one block flagged for recoupon @ Executed
      params.node?.data?.role == "RP" &&
      params.node?.data?.status == ExecutionStrategyStatus.Executed &&
      hasRecoupon(params)
    ) {
      actionsList = getActions(type, params.node?.data.status);
    } else {
      actionsList = getActions(type, params.node?.data.status).slice(1);
    }

    actionsList = actionsList.filter((action: IActionObj) =>
      isActionAllowedByFills(action.id, params.node?.data),
    );

    actionButtons = actionsList.map((returnedAction: IActionObj) => {
      return {
        name: returnedAction.id,
        action: () => {
          const currentInProcess = tradesInProcessStore.getState().tradesInProcess;
          const esid = params.node.data.esid;
          if (!currentInProcess.includes(esid)) {
            tradesInProcessStore.getState().addTradeInProcess([...currentInProcess, esid]);
          }
          returnedAction.function({
            data: params.node.data,
            getAccessTokenSilently: getAccessTokenSilently,
            expandedRowsContext, // Used currently for Not Dealt to close the edit panel window if open.
            setExpandedRowsContext, // Used currently for Not Dealt to close the edit panel window if open.
            setExpandedRowsContextMostRecentlyUpdated, // Used currently for Not Dealt to close the edit panel window if open.
          });
        },
        cssClasses: [
          returnedAction.id.toString().replace(/\s+/g, "") + "ActionButtonER",
          theme == "light" ? "actionButtonERLight" : "actionButtonERDark",
        ],
      };
    });
  } else {
    actionButtons = [];
  }

  // const filterAction = [clearAllFiltersContextMenuObject];

  let multiSecondaryActionButtons: (string | MenuItemDef)[] = [];
  let multiPrimaryActionButton: (string | MenuItemDef)[] = [];
  if (params.api) {
    const selected = params.api.getSelectedRows();
    if (selected.length > 1) {
      const checkSelectedStatus = selected[0].status;
      const checkSelectedType = selected[0].type;
      let okayToClick = true;
      selected.forEach((row: any) => {
        if (
          row.status != checkSelectedStatus ||
          row.type != checkSelectedType
        ) {
          okayToClick = false;
        }
      });

      if (okayToClick == true) {
        const actionsList = getActions(checkSelectedType, checkSelectedStatus);
        multiSecondaryActionButtons = actionsList
          .reduce((acc: any, returnedAction: IActionObj) => {
            if (
              typeof returnedAction.functionMulti != "undefined" ||
              returnedAction.functionMulti != null
            ) {
              acc.push({
                name: returnedAction.id + " on " + selected.length + " trades",
                action: () => {
                  {
                    const newArr = [...tradesInProcessStore.getState().tradesInProcess];
                    selected.forEach((row: any) => {
                      if (!newArr.includes(row.esid)) newArr.push(row.esid);
                    });
                    tradesInProcessStore.getState().addTradeInProcess(newArr);
                    returnedAction.functionMulti({
                      rows: selected,
                      getAccessTokenSilently: getAccessTokenSilently,
                    });
                  }
                },
                cssClasses: [
                  returnedAction.id.toString().replace(/\s+/g, "") +
                    "ActionButtonER",
                  theme == "light"
                    ? "actionButtonERLight"
                    : "actionButtonERDark",
                ],
              });
            }
            return acc;
          }, [])
          .slice(1);
        if (actionsList.length > 0) {
          if (
            typeof actionsList[0].functionMulti != "undefined" ||
            actionsList[0].functionMulti != null
          ) {
            multiPrimaryActionButton = [
              {
                name: actionsList[0].id + " on " + selected.length + " trades",
                action: () => {
                  {
                    const newArr = [...tradesInProcessStore.getState().tradesInProcess];
                    selected.forEach((row: any) => {
                      if (!newArr.includes(row.esid)) newArr.push(row.esid);
                    });
                    tradesInProcessStore.getState().addTradeInProcess(newArr);
                    //   selected.forEach((row: any, index: number) => {
                    //     setTimeout(() => {
                    //       actionsList[0].function({
                    //         data: row,
                    //         getAccessTokenSilently: getAccessTokenSilently,
                    //       });
                    //     }, index * 250);
                    //   });
                    // } else {
                    actionsList[0].functionMulti({
                      rows: selected,
                      getAccessTokenSilently: getAccessTokenSilently,
                    });
                  }
                },
                cssClasses: [
                  "hoveMainTradeButton",
                  actionsList[0].id.toString().replace(/\s+/g, "") +
                    "ActionButtonER",
                  theme == "light"
                    ? "actionButtonERLight"
                    : "actionButtonERDark",
                ],
              },
            ];
            if (
              multiSecondaryActionButtons.length > 0 &&
              typeof multiPrimaryActionButton[0] === "object"
            ) {
              (multiPrimaryActionButton[0] as MenuItemDef<any, any>).subMenu =
                multiSecondaryActionButtons;
            }
          }
        }
      } else if (okayToClick == false) {
        multiSecondaryActionButtons = [];
      }
    }
  }
  const viewTrades = [
    {
      name: "Expand Selected Rows",
      action: () => {
        const selected = params.api.getSelectedRows();
        if (selected.length > 0) {
          selected.forEach((row: any) => {
            const rowNode = params.api.getRowNode(row.esid);
            params.api.setRowNodeExpanded(rowNode, true);
          });
        } else {
          toast.error("No Rows Selected");
        }
      },
    },
    {
      name: "Collapse Selected Rows",
      action: () => {
        const selected = params.api.getSelectedRows();
        if (selected.length > 0) {
          selected.forEach((row: any) => {
            const rowNode = params.api.getRowNode(row.esid);
            params.api.setRowNodeExpanded(rowNode, false);
          });
        } else {
          toast.error("No Rows Selected");
        }
      },
    },
    { ...collapseAllExpandedRowsContextMenuObject },
  ];

  const notDealtItem = [
    {
      name: "Not Dealt",
      cssClasses: ["NotDealtActionButtonER"],
      icon: "", //close,
      action: () => {
        const currentInProcess = tradesInProcessStore.getState().tradesInProcess;
        const esid = params.node.data.esid;
        if (!currentInProcess.includes(esid)) {
          tradesInProcessStore.getState().addTradeInProcess([...currentInProcess, esid]);
        }
        notDealtStoreAction({
          data: params.node.data,
          getAccessTokenSilently: getAccessTokenSilently,
          // Does not need extra props as will redraw rows.
        });
      },
    },
  ];

  // LQC-2576 / LQC-2847 - RP and OP, status rules in canOffloadRisk. The backend
  // re-creates the blocks reversed; they land in Trade Creation on their own.
  // A secondary action: its own group under Toggle Settings, without the primary styling.
  const offloadRiskItem = canOffloadRisk(params.node?.data)
    ? [
        {
          name: "Off-load Risk",
          icon: offloadRiskForRightClick,
          cssClasses: ["OffloadRiskActionButtonER"],
          action: () => {
            offloadRiskStoreAction({
              data: params.node.data,
              executionRequestId: resolveOffloadExecutionRequestId(
                params.node.data,
              ),
              getAccessTokenSilently,
            });
          },
        },
        "separator",
      ]
    : [];

  // LQC-1301 — second entry point for the Trade Settings panel (alongside the
  // blotter cog), for users who hide the cog column. Same feature flag.
  const toggleSettingsItem = featureFlagStore.getState()
    .tradeSettingsSidebarAndCog
    ? [returnToggleSettingsContextMenuObject(params, cryptoID), "separator"]
    : [];

  // LQC-2678 - second route to the edit-expiry popover, alongside the Expires
  // column's pencil. Self-gating (OP + editable status + tradeExpiryEdit), so it
  // sits in the shared block and reaches every status branch below.
  // LQC-3139 - except at Expired, where it leads the menu instead.
  const { leading: leadingEditExpiryItem, inline: editExpiryItem } =
    returnEditExpiryMenuPlacement(params, cryptoID);

  const returnToLiveTradesItem = returnToLiveTradesContextMenuItems(cryptoID);

  const defaultMainTableButtons = [
    ...returnToLiveTradesItem,
    ...tradeAction,
    "separator",
    ...viewTrades,
    "separator",
    ...editExpiryItem,
    ...toggleSettingsItem,
    ...offloadRiskItem,
    { ...clearAllFiltersContextMenuObject },
  ];

  //Return right click meny
  if (params.node) {
    const tradesInProcess = tradesInProcessStore.getState().tradesInProcess;
    const isTradeInProcess = tradesInProcess.includes(params.node.data.esid);
    const anySelectedInProcess = params.api
      ?.getSelectedRows()
      ?.some((row: any) => tradesInProcess.includes(row.esid)) ?? false;
    if (isTradeInProcess || anySelectedInProcess) return ["copy"];

    const status = params.node.data.status;
    const role = params.node.data.role;
    if (role == "OP") {
      if (isEditPanelAllowedAtStatus(status, params.node.data.type)) {
        return [
          ...actionButtons,
          ...editPanelActions,
          ...multiPrimaryActionButton,
          "separator",
          ...viewAllocationsActions,
          ...viewLegsActions,
          "separator",
          ...defaultMainTableButtons,
          "separator",
          ...defaultItems,
          // ...customExport,
        ];
      } else if (status == ExecutionStrategyStatus.New) {
        return [
          ...actionButtons,
          ...notDealtItem,
          "separator",
          ...viewAllocationsActions,
          ...viewLegsActions,
          "separator",
          ...defaultMainTableButtons,
          "separator",
          ...defaultItems,
        ];
      } else if (
        status == ExecutionStrategyStatus.Executed &&
        hasRecoupon(params)
      ) {
        return [
          // ...viewLegsActions,
          ...actionButtons,
          ...multiPrimaryActionButton,
          "separator",
          ...viewAllocationsActions,
          ...viewLegsActions,
          "separator",
          ...defaultMainTableButtons,
          "separator",
          ...defaultItems,
          // ...customExport,
        ];
      } else if (isReCreated) {
        return [
          ...actionButtons,
          ...multiPrimaryActionButton,
          "separator",
          // ...viewAllocationsActions,
          // ...viewLegsActions,
          // "separator",
          ...defaultMainTableButtons,
          "separator",
          ...defaultItems,
          // ...customExport,
        ];
      } else {
        // Expired lands here; it has no status actions, so Edit Expiry takes their slot.
        return [
          ...leadingEditExpiryItem,
          ...actionButtons,
          ...multiPrimaryActionButton,
          "separator",
          ...viewAllocationsActions,
          ...viewLegsActions,
          "separator",
          ...defaultMainTableButtons,
          "separator",
          ...defaultItems,
          // ...customExport,
        ];
      }
    } else if (role == "RP") {
      if (status == ExecutionStrategyStatus.Executed && hasRecoupon(params)) {
        const contextItems = [
          // ...updateExecutionButton,

          ...actionButtons,
          ...multiPrimaryActionButton,
          "separator",
          ...viewAllocationsActions,
          "separator",
          ...defaultMainTableButtons,
          "separator",
          ...defaultItems,
          // ...customExport,
        ];

        // Currently used to add the JBD export - Can be expanded to other users.
        const idsToPass = extractSelectedESIDs(params);

        const tradeExport = sellSideExport({
          selected: idsToPass,
          user,
          getAccessTokenSilently,
        });
        contextItems.push(tradeExport);

        const customExport = userSpecificExport({
          selected: idsToPass,
          user,
          getAccessTokenSilently,
        });
        if (customExport) {
          contextItems.push(customExport);
        }

        return contextItems;
      } else {
        const contextItems = [
          //RP doesn't view legs
          ...actionButtons,
          ...multiPrimaryActionButton,
          "separator",
          ...viewAllocationsActions,
          "separator",
          ...defaultMainTableButtons,
          "separator",
          ...defaultItems,
          // ...customExport,
        ];

        // Currently used to add the JBD export - Can be expanded to other users.
        const idsToPass = extractSelectedESIDs(params);

        const tradeExport = sellSideExport({
          selected: idsToPass,
          user,
          getAccessTokenSilently,
        });
        contextItems.push(tradeExport);

        const customExport = userSpecificExport({
          selected: idsToPass,
          user,
          getAccessTokenSilently,
        });
        if (customExport) {
          contextItems.push(customExport);
        }
        return contextItems;
      }
    } else {
      return [
        ...returnToLiveTradesItem,
        { ...clearAllFiltersContextMenuObject },
        { ...collapseAllExpandedRowsContextMenuObject },
      ];
    }
  } else {
    return [
      ...returnToLiveTradesItem,
      { ...clearAllFiltersContextMenuObject },
      { ...collapseAllExpandedRowsContextMenuObject },
    ];
  }
};
export default GetContextMenuItemsActionSummary;
